<template>
  <div
    v-if="revision"
    class="revision-container"
  >
    <slot name="header" />
    <div class="panel py-8 mt-14">
      <h4 class="revision-title">
        {{ revision.title }}
      </h4>
      <div v-if="!revision.chromePrefilled">
        <div class="revision-company-and-location p2">
          <span
            v-for="(text, i) in companyLocationAndATS"
            :key="text"
          >
            <span
              v-if="i > 0 && text"
              style="font-size: 16px"
              class="px-4"
            >-</span>
            {{ text }}
          </span>
        </div>
      </div>
    </div>
    <RevisionContent
      :fields="fields"
      @copy-clicked="onCopyClicked"
    />
  </div>
</template>

<script>
import { useTracking } from '@/stores/tracking/tracking';
import { joinFooterAndHeaderFields } from '@/helpers/headerFooterFields';
import RevisionContent from './RevisionContent.vue';

export default {
  name: 'DocumentRevision',
  components: { RevisionContent },
  props: {
    jobId: { type: [String, Number], default: null },
    isLinked: { type: Number, default: 0 },
    revision: { type: Object, default: () => ({}) },
  },
  computed: {
    companyLocationAndATS() {
      let fields = [];

      if (!this.revision) return fields;

      fields = [
        this.revision.company,
        this.revision.location,
      ];

      if (this.revision.ats_requisition_id && this.isLinked) {
        fields.push(`Req ${this.revision.ats_requisition_id}`);
      }

      if (!this.isLinked && this.revision.flexible_id) {
        fields.push(this.revision.flexible_id);
      }

      return fields;
    },
    fields() {
      return joinFooterAndHeaderFields(this.revision.description_json?.fields || []);
    },
  },
  methods: {
    onCopyClicked() {
      useTracking().sideBySideCopyButtonClicked({
        id: this.jobId,
        revisionId: this.revision?.id,
        type: this.sideBySideView,
      });
    },
  },
};
</script>
<style scoped lang="less">
@import '@/less/mixins';
:deep(.revision-header) {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 16px;
  &.similar-jobs {
    align-items: center;
    margin-top: -8px;
  }
}
.revision-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  .panel {
    padding: 16px 16px 16px 0;
    width: 100%;
    margin-bottom: 28px;
    border-radius: 10px;
  }
}
.revision-title {
  font-weight: 700;
  line-height: 28px;
  min-height: 32px;
}
.arrow.v-btn {
  background: @bg-canvas;
  height: 32px;
  width: 32px;
  user-select: none;
}
.revision-company-and-location {
  text-align: left;
  padding-top: 4px;
}
</style>
